import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdvancedCalculatorComponent } from './advanced-calculator/advanced-calculator.component';
import { SavedPowerPlantsComponent } from './saved-power-plants/saved-power-plants.component';
import { PowerPlantDetailsComponent } from './power-plant-details/power-plant-details.component';
import { UserRole } from '../../common/models/user/user-role.enum';
import { AuthGuard } from '../../common/guards/auth.guard';
import { ImplementationPlanComponent } from './implementation-plan/implementation-plan.component';
import { OfferRequestsComponent } from './offer-requests/offer-requests.component';
import { AddPriceComponent } from '../../common/components/prices/upsert-price/add-price/add-price.component';
import { EditPriceComponent } from '../../common/components/prices/upsert-price/edit-price/edit-price.component';
import { PricesComponent } from '../../common/components/prices/prices.component';
import { SimpleImplementationPlanComponent } from './simple-implementation-plan/simple-implementation-plan.component';
import { BusinessDashboardComponent } from './business-dashboard/business-dashboard.component';

const allExceptUnpaidUse = [
  UserRole.ROLE_PERSONAL,
  UserRole.ROLE_BUSINESS,
  UserRole.ROLE_BUSINESS_PLUS,
  UserRole.ROLE_BUSINESS_EXP,
  UserRole.ROLE_BUSINESS_PLUS_EXP,
];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'advanced-calculator',
    pathMatch: 'full',
  },
  {
    path: 'advanced-calculator',
    component: AdvancedCalculatorComponent,
    canActivate: [AuthGuard],
    data: {
      roles: allExceptUnpaidUse,
    },
  },
  { path: 'saved-power-plants', component: SavedPowerPlantsComponent },
  { path: 'power-plant/:id', component: PowerPlantDetailsComponent },
  {
    path: 'implementation-plan/:id',
    component: ImplementationPlanComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.ROLE_PERSONAL,
      ],
    },
  },
  {
    path: 'simple-implementation-plan/:id',
    component: SimpleImplementationPlanComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.ROLE_PERSONAL,
      ],
    },
  },
  {
    path: 'offer-requests',
    component: OfferRequestsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.ROLE_BUSINESS_PLUS,
      ],
    },
  },
  {
    path: 'my-prices',
    component: PricesComponent,
    canActivate: [AuthGuard],
    data: {
      roles: allExceptUnpaidUse,
    },
  },
  {
    path: 'my-prices/add',
    component: AddPriceComponent,
    canActivate: [AuthGuard],
    data: {
      roles: allExceptUnpaidUse,
    },
  },
  {
    path: 'my-prices/edit/:id',
    component: EditPriceComponent,
    canActivate: [AuthGuard],
    data: {
      roles: allExceptUnpaidUse,
    },
  },
  {
    path: 'business-dashboard',
    component: BusinessDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.ROLE_BUSINESS_PLUS,
        UserRole.ROLE_BUSINESS_PLUS_EXP,
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerRoutingModule {
}
